import React, { useState, useEffect } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
// Replace ReactQuill with SunEditor
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import fetchData from "../../api/fetchApi";
import SuccessAlert from "../common/SuccessAlert";
import { UploadCloud, File as FileIcon, X } from 'lucide-react';
import CategoriesList from "../common/CategoriesList";

// Remove quillModules and add a toolbar config for SunEditor
const sunEditorOptions = {
  buttonList: [
    ['undo', 'redo'],
    ['bold', 'underline', 'italic', 'strike'],
    ['fontSize', 'formatBlock'],
    ['fontColor', 'hiliteColor'],
    ['align', 'list', 'lineHeight'],
    ['link', 'image', 'video'],
    ['removeFormat'],
  ],
  defaultTag: 'div'
};

export default function ViewLawPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const [showAlert, setShowAlert] = useState(false);
  
const [state, setState] = useState({});
  // Form fields state
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
    const [lawnumber, setLawnumber] = useState("");
  const [content, setContent] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [journalNumber, setJournalNumber] = useState(""); // Not in API, will be empty
  const [articleNumber, setArticleNumber] = useState(""); // Not in API, will be empty
  const [basicLawName, setBasicLawName] = useState(""); // Not in API, will be empty
  const [lawType, setLawType] = useState("التعديلات القانونية"); // Default, not from API
  // Categories from API
  const [categories, setCategories] = useState([]);
  const [categoryUuid, setCategoryUuid] = useState("");
const [files, setFiles] = useState([]);
const [fileUuids, setFileUuids] = useState([]);
const [uploading, setUploading] = useState(false);
const [uploadError, setUploadError] = useState(null);
const [lawData, setLawData] = useState(null);

    // Handle file deletion
    const handleDeleteFile = async (fileUuid) => {
      if (!id || !fileUuid) return;
      try {
        await fetchData(`admin/law/${id}/file/${fileUuid}`, 'DELETE');
        // Remove file from UI
        setLawData((prev) => ({
          ...prev,
          files: prev.files.filter((f) => f.uuid !== fileUuid),
        }));
        setShowAlert(true);
      } catch (err) {
        alert('فشل حذف الملف');
      }
    };

const handleFileChange = async (e) => {
  if (e.target.files && e.target.files.length > 0) {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    setUploading(true);
    setUploadError(null);
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append('file', file));
      // Use fetch directly for file upload
      const res = await fetchData('upload', 
       'POST',
        formData,
      );
     
      const uuids = res.uuid;
     
      setFileUuids(uuids);
    } catch (err) {
      setUploadError('فشل رفع الملفات');
      setFileUuids([]);
    } finally {
      setUploading(false);
    }
  }
};

  useEffect(() => {
    const fetchLaw = async () => {
      try {
        const data = await fetchData(`admin/law?uuid=${id}`);
        setTitle(data.title || "");
        setDescription(data.content_plain?.substring(0, 150) + '...' || "");
        setContent(data.content || "");
        setReferenceNumber(data.reference_number || "");
        setArticleNumber(data.published_date || "");
        setJournalNumber(data.journal_number || "");
        setBasicLawName(data.basic_law_name || "");
        setLawType(data.law_type || "التعديلات القانونية");
        setCategoryUuid(data.category_uuid || "");
        setLawData(data);
      } catch (error) {
        console.error("Failed to fetch law:", error);
      }
    };
    if (id) {
      fetchLaw();
    }
  }, [id]);

  // Fetch categories once
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetchData('admin/law-categories');
        const items = Array.isArray(res) ? res : (res?.items || res?.data || res?.categories || []);
        setCategories(Array.isArray(items) ? items : []);
      } catch (e) {
        console.error('Failed to load categories', e);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        title: title || "",
        reference_number: referenceNumber || "",
        content: content || "",
      
        // map articleNumber to published_date if present
        published_date: articleNumber || undefined,
        journal_number: journalNumber || undefined,
        basic_law_name: basicLawName || undefined,
        law_number:  lawnumber|| referenceNumber,
     
        category_uuid: categoryUuid || undefined,
      };
      await fetchData(`admin/law?uuid=${id}`, 'PUT', 
        JSON.stringify(payload)
      );
      setShowAlert(true);
    } catch (err) {
      console.error('Failed to update law', err);
    }
  };

  return (
    <div className="min-h-screen bg-white p-6" dir="rtl">
          <h1>
            <span className="text-2xl font-bold text-gray-800">عرض / تعديل القانون</span>
        </h1>
        <br></br>
      <div className=" mx-auto">
      
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* File Upload Section */}
          <div className="border border-dashed border-gray-300 rounded-2xl p-6 text-center">
            <label htmlFor="file-upload" className="cursor-pointer flex flex-col items-center justify-center">
              <UploadCloud className="w-10 h-10 text-gray-400 mb-2" />
              <h3 className="text-lg font-semibold text-gray-800">اختر صورة غلاف القانون</h3>
              <p className="text-sm text-gray-500">تنسيقات JPEG و PNG و PDF و MP4، حتى 50 ميجابايت.</p>
            </label>
            <input id="file-upload" type="file" className="hidden"  multiple onChange={handleFileChange} />
        {files.length > 0 && (
  <div className="mt-4 bg-gray-100 border border-gray-200 rounded-lg p-3 flex flex-col gap-2 text-sm">
    {files.map((file, idx) => (
      <div key={idx} className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FileIcon className="w-8 p-8 text-red-500" />
          <div>
            <p className="font-semibold text-gray-800">{file.name}</p>
            <p className="text-gray-500">{(file.size / 1024).toFixed(2)} كيلوبايت</p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setFiles(files.filter((_, i) => i !== idx))}
          className="text-gray-500 hover:text-red-600"
        >
          <X size={20} />
        </button>
      </div>
    ))}
  </div>
)}
          </div>

          {/* Law Title */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">عنوان القانون</label>
            <input type="text" className="w-full border border-gray-300 rounded-lg p-3 text-sm" placeholder="إضافة عنوان جديد" value={title} onChange={e => setTitle(e.target.value)} />
          </div>

          {/* Law Description */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">وصف صغير للقانون..</label>
            <input type="text" className="w-full border border-gray-300 rounded-lg p-3 text-sm" placeholder="ضيف وصف بسيط يظهر تحت عنوان القانون" value={description} onChange={e => setDescription(e.target.value)} />
          </div> */}

          {/* Law Content */}
          <div className="bg-white  border-gray-200 rounded-lg">
            <div className="p-3 border-b border-gray-200">
              <label className="text-sm font-medium text-gray-700">محتوى القانون</label>
            </div>
            <SunEditor
              setContents={content}
              onChange={setContent}
              setOptions={sunEditorOptions}
              height="300px"
            />
          </div>
          
          {/* Metadata Fields */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 pt-10">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">رقم المادة</label>
              <input type="text" className="w-full border border-gray-300 rounded-lg p-3 text-sm" value={referenceNumber} onChange={e => {
                setReferenceNumber(e.target.value)
               setLawnumber(e.target.value);


              }} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">السنة</label>
              <input type="text" className="w-full border border-gray-300 rounded-lg p-3 text-sm" value={articleNumber} onChange={e => setArticleNumber(e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">رقم الجريدة</label>
              <input type="text" className="w-full border border-gray-300 rounded-lg p-3 text-sm" value={journalNumber} onChange={e => setJournalNumber(e.target.value)} />
            </div>
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">اسم القانون الأساسي</label>
              <input type="text" className="w-full border border-gray-300 rounded-lg p-3 text-sm" value={basicLawName} onChange={e => setBasicLawName(e.target.value)} />
            </div> */}
          </div>
          
          {/* Law Type Selection (Categories) */}
          <div>
            <label className="block text sm font-medium text-gray-700 mb-2">تحديد نوع القانون</label>
            <CategoriesList
              value={categoryUuid}
              onChange={setCategoryUuid}
              categories={categories}
            />
          </div>
    <div className="mb-10 grid grid-cols-1 md:grid-cols-1 gap-8">
          {/* Files Card */}
          {lawData?.files && lawData?.files.length > 0 && (
            <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col gap-4">
              <label className="block font-semibold mb-2 text-lg text-gray-700">الملفات</label>
              <div className="flex flex-wrap gap-6">
                {lawData?.files.map((file) => (
                  <div key={file.uuid} className="flex flex-col items-center border rounded-xl p-4 shadow-md bg-gray-50">
                    {file.url && (
                      <img
                        src={file.url}
                        alt={file.name}
                        className="max-w-xs max-h-64 border rounded-xl shadow-md object-contain mb-2"
                      />
                    )}
                    <span className="font-semibold text-gray-800 mb-2">{file.name}</span>
                    <button
                      className="px-4 py-1 rounded bg-red-600 text-white text-sm mt-2"
                      onClick={() => handleDeleteFile(file.uuid)}
                    >
                      حذف الملف
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* History Card */}
          {lawData?.history && lawData?.history.length > 0 && (
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <h3 className="font-semibold mb-4 text-lg text-gray-700">السجل</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border rounded-xl overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2">الإجراء</th>
                      <th className="border px-3 py-2">تم بواسطة</th>
                      <th className="border px-3 py-2">التاريخ</th>
                      <th className="border px-3 py-2">UUID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lawData?.history.map((h, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="border px-3 py-2">{h.action}</td>
                        <td className="border px-3 py-2">{h.performed_by}</td>
                        <td className="border px-3 py-2">{h.timestamp}</td>
                        <td className="border px-3 py-2">{h.uuid}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Versions Card */}
          {lawData?.versions && lawData?.versions.length > 0 && (
            <div className="bg-white rounded-2xl shadow-lg p-6">
              <h3 className="font-semibold mb-4 text-lg text-gray-700">الإصدارات</h3>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border rounded-xl overflow-hidden">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-3 py-2">رقم الإصدار</th>
                      <th className="border px-3 py-2">تاريخ الإنشاء</th>
                      <th className="border px-3 py-2">UUID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lawData?.versions.map((v, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="border px-3 py-2">{v.version_number}</td>
                        <td className="border px-3 py-2">{v.created_at}</td>
                        <td className="border px-3 py-2">{v.uuid}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
  </div>
          {/* Action Buttons */}
          <div className="flex justify-end items-center gap-4 pt-4 border-t border-gray-200">
            <button type="button" onClick={() => navigate(-1)} className="px-6 py-2.5 rounded-lg border border-gray-300 bg-white text-gray-800 font-semibold text-sm">إلغاء</button>
            <button type="submit" className="px-6 py-2.5 rounded-lg bg-[#8C1C13] text-white font-semibold text-sm">
                تعديل القانون
                </button>
          </div>
        </form>
      </div>
      {showAlert && <SuccessAlert message="تم تحديث القانون بنجاح." onClose={() => setShowAlert(false)} />}
    </div>
  );
}
